var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,8h-3.238c-0.726,0-1.348-0.52-1.476-1.235l-0.201-1.118C19.913,4.693,19.085,4,18.116,4h-6.232c-0.968,0-1.797,0.693-1.968,1.646L9.715,6.765C9.587,7.48,8.965,8,8.239,8H5c-1.105,0-2,0.895-2,2v13c0,1.105,0.895,2,2,2h20c1.105,0,2-0.895,2-2V10C27,8.895,26.105,8,25,8z M15,22c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S18.314,22,15,22z M15,20c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S17.209,20,15,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.2b243a1b3f26c038ab2279a4a26f8e1f.svg";
export { ForwardRef as ReactComponent };